import { render, staticRenderFns } from "./RewardName.vue?vue&type=template&id=24ae15b4&"
import script from "./RewardName.vue?vue&type=script&lang=js&"
export * from "./RewardName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ae15b4')) {
      api.createRecord('24ae15b4', component.options)
    } else {
      api.reload('24ae15b4', component.options)
    }
    module.hot.accept("./RewardName.vue?vue&type=template&id=24ae15b4&", function () {
      api.rerender('24ae15b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/RewardName.vue"
export default component.exports